import React from 'react';
import { StarIcon } from 'lucide-react';
const QUOTES = [{
  quote: 'I used to spend hours preparing drills and organizing each session. Now I choose the right material, adapt it to my players, and I’m ready for court.',
  name: 'Michael R.',
  location: 'Miami, USA'
}, {
  quote: 'The tactical resources helped me give every exercise a clearer purpose. My sessions now connect much better with real match situations.',
  name: 'Daniel W.',
  location: 'Sydney, Australia'
}, {
  quote: 'I had drills, notes, and ideas scattered everywhere. Now I have one organized system that I can use and adapt every week.',
  name: 'James T.',
  location: 'Auckland, New Zealand'
}];
export function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-0.5 ${className}`} aria-label="5 out of 5 stars" data-id="element-192" data-mp="271timz7hn033">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-urgent text-urgent" aria-hidden="true" data-id="element-193" data-mp="2bzv2hmcqn3fm" />)}
    </div>;
}
export function QuickTestimonials() {
  return <section aria-label="Coach quotes" className="w-full bg-white px-4 pb-8 sm:px-6" data-id="element-194" data-mp="2kq5koquii67t">
      <div className="mx-auto max-w-5xl" data-id="element-195" data-mp="2ypf37x66xcey">
        <p className="mb-2 text-center font-head text-[10px] font-semibold uppercase tracking-wider text-softgray" data-id="element-196" data-mp="2yo3y9u10dym9">
          Sample testimonial — replace with verified customer
        </p>
        <div className="grid gap-2.5 md:grid-cols-3" data-id="element-197" data-mp="261rimi4x6lsb">
          {QUOTES.map(item => <figure key={item.name} className="rounded-xl border border-charcoal/10 bg-ivory p-3.5" data-id="element-198" data-mp="21zxo6rlbie0l">
              <Stars data-id="element-199" data-mp="2fqt24iaoblb1" />
              <blockquote className="mt-1.5 text-[13px] leading-snug text-charcoal" data-id="element-200" data-mp="2fs42e84wuaxe">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-2 font-head text-xs font-semibold uppercase text-charcoal" data-id="element-201" data-mp="1na8h6fqjnfse">
                {item.name}
                <span className="block font-body text-[11px] font-normal normal-case text-softgray" data-id="element-202" data-mp="1ibx7c50915a6">
                  {item.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}